import React from "react";
import EmptyBox from "./extras/EmptyBox";
import { ReactComponent as EmptyNotesSvg } from "../../assets/images/cm-empty-notes.svg";

const TaskSection = () => {
  return (
    <div className="flex w-full h-full items-center justify-center">
      <span className="flex flex-col items-center">
        {/* <EmptyBox width={350} height={350} />
        <p className="text-2xl">Nothing to see here.</p> */}
        <EmptyNotesSvg />
      </span>
    </div>
  );
};

export default TaskSection;
